import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var RosterActions = require("lib/actions/RosterActions");
var DropDownOptions = require("components/utility/DropDownOptions");
var EditableGoals = require("components/org/roster/EditableGoals");

var RosterSelectors = require("lib/selectors/RosterSelectors");

require("org/preferences/expectation_period_preference.scss");

@connect(
	(state, props) => {
		var refPrefs = {}

		// USER IS A TEACHER
		if (CurrentUser.isTeacherAdmin()) {
			var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
			if (admin && admin.prefs) {
				refPrefs = admin.prefs;
			}
		} else {
			// USER IS DISTRICT ADMIN
			if (CurrentUser.isDistrictAdmin()) {
				var selectedOrgs = RosterSelectors.districtOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_district_org_id] }
				})
			} else {
				// USER IS SCHOOL ADMIN
				var selectedOrgs = RosterSelectors.schoolOrgs({
					state, conditions: { ids: [CurrentUser.get().primary_school_org_id] }
				})
			}

			if (selectedOrgs.length > 0) {
				refPrefs = selectedOrgs[0].prefs
			}
		}
		
		return {
			refPrefs
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            if (CurrentUser.isDistrictAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
	                filters:{ids: [CurrentUser.get().primary_district_org_id]}, 
	                embeds:['district_org.prefs'],
	                cache: true
	            }))])
            } else if (CurrentUser.isSchoolAdmin()) {
            	return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
	                filters:{ids: [CurrentUser.get().primary_school_org_id]}, 
	                embeds:['school_org.prefs'],
	                cache: true
	            }))])
            } else {
            	return Promise.all([ dispatch(RosterActions.fetchAdmins({
	                filters:{ids: [CurrentUser.get().id]}, 
	                embeds:['user.prefs'],
	                cache: true
	            }))])
            }
            return Promise.all([])
        },

		onChange: (prefsUpdate) => {
			// WE NEED TO RELOAD PAGE TO PREVENT HAVING STUDENT LISTS WITH WRONG PREFERENCES
			var confirmMessage = "Do you want to apply this setting to corresponding students/classes? Selecting yes will override the individual student and class preferences you may have set."
			var resetStudentLists = false

			if (CurrentUser.isTeacherAdmin()) {
				
				if (confirm(confirmMessage)) {
					resetStudentLists = true
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: "Expecation Periods were saved!", icon: "ok-sign"
				});
				return dispatch( RosterActions.updateAdminPrefs({
					id: CurrentUser.get().id,
					resetStudentLists: resetStudentLists,
					update: prefsUpdate
				}), window.location.reload())
			} else {

				confirmMessage = confirmMessage.replace("you may", "you or other teachers or admins may")
				if (confirm(confirmMessage)) {
					resetStudentLists = true
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Information Edited", text: "Expecation Periods were saved!", icon: "ok-sign"
				});

				if (CurrentUser.isDistrictAdmin()) {
					return dispatch(RosterActions.updateDistrictOrgPrefs({
						currentUserID: CurrentUser.get().id,
						resetPrefs: resetStudentLists,
						districtOrgID: CurrentUser.get().primary_district_org_id,
						update: prefsUpdate
					}), window.location.reload())
				} else if (CurrentUser.isSchoolAdmin()) {
					return dispatch(RosterActions.updateSchoolOrgPrefs({
						currentUserID: CurrentUser.get().id,
						resetPrefs: resetStudentLists,
						schoolOrgID: CurrentUser.get().primary_school_org_id,
						update: prefsUpdate
					}), window.location.reload())
				}
			}
		}
	})
)

@providePopulateData({waitForLoad:true})
class ExpectationPeriodPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("ExpectationPeriodPreference");
		this.state = {refPrefs: props.refPrefs, save: false}
	}

	
	selectGradeLevel(selectedGradeLevel) {
		this.setState({selectedGradeLevel})
	}
	
	editPeriodPreference(change, callback) {
		var refPrefs = this.state.refPrefs
		_.each(change, (val,key) => {
			refPrefs[key] = val	
		})
		
		this.setState({refPrefs, save: true})
	}

	onSave() {
		var prefsUpdate = {"expectations_time_period_starts": this.state.refPrefs["expectations_time_period_starts"],
			"expectations_time_period": this.state.refPrefs["expectations_time_period"]}
		this.props.onChange(prefsUpdate)
		this.setState({save: false})
	}

	// disclaimer that digests need to be recalculated overnight.
	renderDisclaimer(){
		if(
			this.state.refPrefs.expectations_time_period != this.props.refPrefs.expectations_time_period || 
			! _.isEqual(this.state.refPrefs.expectations_time_period_starts, this.props.refPrefs.expectations_time_period_starts)
		) {
			return (
				<div className="disclaimer"> 
					<p>Note: Changes to data settings are recalculated overnight. This change will be reflected on your data pages <i>tomorrow</i>.</p>
				</div>
			)
		}
	}

	render() {
		
		if (this.state.save) {
			var saveAction = (
				<div className="saveExpectationPeriod">
					<button className="btn btn-primary" onClick={this.onSave.bind(this)}>Save</button>
				</div>
			)
		}

		if (this.state.refPrefs && _.keys(this.state.refPrefs).length > 0) {
			var goals = <EditableGoals prefs={this.state.refPrefs} onEditPrefs={this.editPeriodPreference.bind(this)} hideHeader={true} periodSelector />
		}
		return (
			<div className="expectationPeriodPreference">
				<p>Your students' progress will be calculated with the following interval:</p>
				{this.renderDisclaimer()}
				{ goals }
				{ saveAction }
			</div>
		)
	}

}

ExpectationPeriodPreference.WrappedComponent.propTypes = StrictPropTypes({
	populateData: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	refPrefs: PropTypes.object.isRequired
});

module.exports = ExpectationPeriodPreference;


// WEBPACK FOOTER //
// ./modules/components/org/preferences/ExpectationPeriodPreference.js